import { Platform } from 'react-native'
//import firebase from '@react-native-firebase/app'
//import analytics, { FirebaseAnalyticsTypes } from '@react-native-firebase/analytics'

// Initialize Firebase Analytics for ios & android
//const appAnalytics: FirebaseAnalyticsTypes.Module = analytics()

export const initializeRNFirebase = firebaseConfig => {
	// if (!firebase.apps.length && Platform.OS !== 'web') {
	// 	firebase.initializeApp(firebaseConfig)
	// }
}

// User opens the app
export const logAppOpenAnalytics = () => {
	//appAnalytics.logAppOpen()
}

// User searches for a menu item
export const logSearchMenuAnalytics = searchTerm => {
	// appAnalytics.logSearch({
	// 	search_term: searchTerm || '',
	// })
}

// User adds an item to their cart
export const logAddItemAnalytics = (total, itemObj) => {
	// appAnalytics.logAddToCart({
	// 	currency: 'CAD',
	// 	value: total,
	// 	items: [itemObj],
	// })
}

// User selects a menu from the home screen (brand or category)
export const logSelectMenuAnalytics = (type, id) => {
	// appAnalytics.logSelectContent({
	// 	content_type: type,
	// 	item_id: id,
	// })
}

// User selects an item from the menu
export const logSelectItemAnalytics = (id, name, price, itemObj) => {
	// appAnalytics.logSelectItem({
	// 	content_type: 'menu_item',
	// 	item_list_id: id,
	// 	item_list_name: name,
	// 	items: [itemObj],
	// })
	// appAnalytics.logViewItem({
	// 	value: parseFloat(price.substring(1)) || 0, //price is in format $x.xx
	// 	currency: 'CAD',
	// 	items: [itemObj],
	// })
}

// User goes to 'Cart' screen
export const logViewCartAnalytics = (total, items) => {
	// appAnalytics.logViewCart({
	// 	items: items,
	// 	currency: 'CAD',
	// 	value: total,
	// })
}

// User presses "Delete" button on an item in the cart
export const logRemoveFromCartAnalytics = (total, itemObj) => {
	// appAnalytics.logRemoveFromCart({
	// 	currency: 'CAD',
	// 	value: total,
	// 	items: [itemObj],
	// })
}

// User presses "Checkout Now" button on the cart screen
export const logBeginCheckoutAnalytics = (total, items) => {
	// appAnalytics.logBeginCheckout({
	// 	currency: 'CAD',
	// 	value: total,
	// 	items: items,
	// })
}

// User adds a payment method for checkout
export const logAddCheckoutPaymentAnalytics = (couponId = null, value, items) => {
	//const type = global.kiosk ? 'kiosk' : Platform.OS === 'web' ? 'web' : 'mobile'
	// appAnalytics
	// 	.logAddShippingInfo({
	// 		coupon: couponId,
	// 		currency: 'CAD',
	// 		value: value,
	// 		items: items,
	// 		shipping_tier: type + '_pickup',
	// 	})
	// 	.then(() => {
	// 		appAnalytics.logAddPaymentInfo({
	// 			coupon: couponId,
	// 			currency: 'CAD',
	// 			value: value,
	// 			items: items,
	// 		})
	// 	})
}

// User successfully completes checkout and pays for their order
export const logCompleteCheckoutAnalytics = (total, orderId, items, taxes) => {
	// appAnalytics.logPurchase({
	// 	currency: 'CAD',
	// 	items: items,
	// 	value: total * 100,
	// 	transaction_id: orderId,
	// 	tax: taxes,
	// })
}

// User logs in to their account
export const logLoginAnalytics = () => {
	let type = ''
	if (Platform.OS === 'ios') {
		type = 'ios'
	} else if (Platform.OS === 'android') {
		type = 'android'
	} else if (Platform.OS === 'web') {
		type = 'web'
	}

	//appAnalytics.logLogin({ method: type })
}

// User successfully signs up for a new account
export const logSignUpAnalytics = () => {
	let type = ''
	if (Platform.OS === 'ios') {
		type = 'ios'
	} else if (Platform.OS === 'android') {
		type = 'android'
	} else if (Platform.OS === 'web') {
		type = 'web'
	}
	//appAnalytics.logSignUp({ method: type })
}

// User navigates to a screen in the app
export const logScreenViewAnalytics = screenName => {
	//appAnalytics.logScreenView({
	// 	screen_name: screenName,
	// 	screen_class: screenName,
	// })
}
